import { getFormattedTimeDateFileName } from '@src/common/util/formatter';

export function getFileName(searchValue: string, ext: string) {
  const date = getFormattedTimeDateFileName(new Date());
  const value = searchValue
    .toLowerCase()
    .replace(/@/g, '_at_')
    .replace(/[^a-z0-9._-]/g, '');

  return `LinkAnalysis_${value}_${date}.${ext}`;
}
